import { Footer } from './components/Footer'
import { Navbar } from './components/Navbar'
import { EmptyState } from './components/Feedback'
import { ScrollReveal } from './components/ScrollReveal'
import { useLocation } from './lib/router'
import { HomePage } from './pages/HomePage'
import { LeaderboardPage } from './pages/LeaderboardPage'
import { PlayerProfilePage } from './pages/PlayerProfilePage'
import { TournamentDetailPage } from './pages/TournamentDetailPage'
import { TournamentsPage } from './pages/TournamentsPage'
import { TntWarsPage } from './pages/TntWarsPage'
import { StatusPage } from './pages/StatusPage'
import { PrivacyPage } from './pages/PrivacyPage'
import { TermsPage } from './pages/TermsPage'
import { CookiesPage } from './pages/CookiesPage'

export default function App() {
  const { pathname } = useLocation()
  let page

  if (window.location.hostname === 'status.blastcore.it' || pathname === '/status' || pathname === '/status/') {
    page = <StatusPage />
  } else if (pathname === '/') page = <HomePage />
  else if (pathname === '/tntwars') page = <TntWarsPage />
  else if (pathname === '/leaderboard') page = <LeaderboardPage />
  else if (/^\/player\/[^/]+\/?$/.test(pathname)) page = <PlayerProfilePage />
  else if (pathname === '/tournaments') page = <TournamentsPage />
  else if (/^\/tournaments\/[^/]+\/?$/.test(pathname)) {
    page = <TournamentDetailPage />
  } else if (pathname === '/privacy') {
    page = <PrivacyPage />
  } else if (pathname === '/terms') {
    page = <TermsPage />
  } else if (pathname === '/cookies') {
    page = <CookiesPage />
  } else {
    page = (
      <main className="section page">
        <EmptyState
          message="La rotta richiesta non fa parte del network BlastCore."
          title="Pagina non trovata"
        />
      </main>
    )
  }

  return (
    <div className="app-shell">
      <Navbar />
      <ScrollReveal routeKey={pathname} />
      {page}
      <Footer />
    </div>
  )
}
